import * as React from 'react';
import {Component, deps} from '../lib/component';
import {classes, style} from 'typestyle';
import {colorWhite, colorBrand, colorSlate} from "../theme/color";
import {
    betweenJustified,
    wrap,
    center,
    horizontal,
    startJustified,
    vertical, centerJustified
} from "csstips";
import HeaderImage from '../static/LICKDxFSC_Set_5_UseMusic_headphones.jpg';
import MabelImage from '../static/Mabel1080x1080.jpg';
import XxxTentacionImage from '../static/XXXtentacion1080x1080.jpg';
import NoelGallagherImage from '../static/NoelGallagher1080x1080.jpg';
import {fontBody, fontHeading} from "../theme/font";
import {ButtonPill} from "../components/button-pill";
import {mediaMobileOnly, mediaTablet, mediaTabletOnly} from "../theme/media";
import {Head} from "./head";

export interface FullscreenPageProps {};

export class FullscreenPage extends Component<FullscreenPageProps>{
    componentDidMount(): void {
        let searchParams = new URLSearchParams(window.location.search);

        if(searchParams.has('fsUserId')) {
            document.cookie = "mcn_user_id=" + searchParams.get('fsUserId');
        }

        if(searchParams.has('token')) {
            document.cookie = "mcn_token=" + searchParams.get('token');
        }

        document.cookie = "mcn_name=fullscreen";

    }

    render(): JSX.Element | false | null {
        return (
            <div className={classes(FullscreenPage.styles.background)}>
                <Head />
                <div className={classes(FullscreenPage.styles.container)}>
                    <div className={style({paddingBottom: "16px"})}>
                        <img className={classes(FullscreenPage.styles.headerImage)} src={HeaderImage} />
                    </div>

                    <div className={classes(FullscreenPage.styles.content)}>
                        <h1 className={classes(FullscreenPage.styles.h1)}>What is Lickd?</h1>
                        <p>
                            Lickd is the first (and only) online platform that allows you to quickly and easily license <strong>popular music</strong> from <strong>signed artists</strong> for your social videos. You’ll keep all of your advertising revenue and never worry about a copyright claim again.</p>
                        <p>
                            Each track in our 50,000+ strong library (including instrumentals) is protected by our VOUCH technology, which means you can finally use the music you love without the fear of copyright infringement. Where we can't offer automatic clearances, our team will be on hand to remove any claims asap with no impact on your channel. Your ad revenue is now yours to keep.
                        </p>

                        <h1 className={classes(FullscreenPage.styles.h1)}>VIP Lickd benefits</h1>
                        <p>As a part of the Fullscreen network, when you sign up you’ll now have access to exclusive benefits and deals from Lickd:</p>
                        <ul>
                            <li>Your first track is free</li>
                            <li>Your second order is 50% off</li>
                            <li>You get 10% off every order as long as you’re part of Fullscreen</li>
                        </ul>

                        <div className={classes(FullscreenPage.styles.downloadCta)}>
                            <ButtonPill href={"/?show-sign-up&?utm_medium=referral&utm_source=fullscreen&utm_campaign=fullscreen-lander-download"} primary={true}>Download first track</ButtonPill>
                        </div>

                        <h2 className={classes(FullscreenPage.styles.h1)}>Lickd's hottest tracks</h2>
                        <div className={classes(FullscreenPage.styles.hottestTracks)}>
                            <div className={classes(FullscreenPage.styles.artist)}>
                                <img src={MabelImage}/>
                                With 2.5 billion streams worldwide, global chart queen, Mabel, is the latest artist to drop from our collab with Universal. Mabel’s pumping-pop classic “Don’t Call Me Up” is a platinum single you don’t want to miss out on.
                            </div>

                            <div className={classes(FullscreenPage.styles.artist)}>
                                <img src={XxxTentacionImage}/>
                                XXXtentacion’s track Sad! sent the artist’s second studio album to the number one spot on the Billboard 200. The raw energy in his music’s guaranteed to give your next video the edge.
                            </div>

                            <div className={classes(FullscreenPage.styles.artist)}>
                                <img src={NoelGallagherImage}/>
                                The double-platinum artist is back with a new EP. Check out ‘Blue Moon Rising’ for an energetic track with a driving, hypnotic bassline that could be perfect for your next video.
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    static styles = {
        background: style({
            ...vertical,
            ...center,
            ...startJustified,
            minHeight: '100%',
            padding: 0,
            backgroundColor: "rgb(249, 249, 249)",
        }),
        container: style(
            {
                width: 1280,
                overflow: "hidden",
                paddingBottom: "100px",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 4px",
                backgroundColor: colorWhite.toString(),
            },
            mediaMobileOnly({
                width: "100%"
            }),
            mediaTabletOnly({
                width: "100%"
            })
        ),
        headerImage: style({
            maxWidth: "100%",
            height: "auto",
        }),
        content: style(
            {
                padding: "0 160px",
                color: colorSlate.toString(),
                fontFamily: fontBody,
                fontSize: "16px",
                fontWeight: 400,
                $nest: {
                    '& ul': {
                        paddingLeft: '25px',
                        $nest: {
                            '& li': {
                                paddingLeft: "10px"
                            }
                        }
                    },
                   '& p,li': {
                       lineHeight: "28px",
                   }
                }
            },
            mediaMobileOnly({
                width: "100%",
                padding: "0 30px",
            }),
            mediaTabletOnly({
                width: "100%",
                padding: "0 50px",
            })
        ),
        h1: style({
            color: colorBrand.toString(),
            fontSize: "30px",
            fontFamily: fontHeading,
            fontWeight: 600,
            marginTop: "60px;"
        }),
        hottestTracks: style(
            {
                ...horizontal,
                ...betweenJustified,
                ...wrap
            },
            mediaMobileOnly({
                ...centerJustified
            })
        ),
        artist: style({
            width: '300px',
            lineHeight: "28px",
            marginBottom: "20px",
            $nest: {
                '&> img': {
                    width: '300px',
                    marginBottom: '29px'
                }
            }
        }),
        downloadCta: style({
            marginTop: "53px",
            ...vertical,
            ...center,
            ...startJustified,
        })
    }
}